/**
 * AUTOGENERATED FILE. DO NOT EDIT.
 *
 * This file is generated by running yarn i18n:build, do not edit it manually.
 *
 * If you wish to update it, please run yarn i18n:build.
 */
/* eslint-disable no-restricted-imports */
import {i18n} from "@lingui/core";
import * as React from "react";

import {RequestInfo} from "@khan/shared-core";

// We statically import the English strings as we use them as a fallback
// for locales that don't have any translations. Additionally, it improves
// the performance of the English site by not having to load the strings at
// runtime.
// NOTE(john): This is replaced with the actual English strings in the build
// process.
const enStrings = {"uyJsf6":["About"],"k4I7F8":["Impact"],"KM6m8p":["Team"],"smGSLU":["Interns"],"tDE0mP":["Content Specialists"],"HyFz7F":["Leadership"],"3JSu/M":["Supporters"],"cW8Uak":["Translators"],"astDB+":["Blog"],"QAZsqC":["Translation supporters"],"dZWZsK":["American Sign Language"],"2a5k3J":["Advocate(s)/Non-profit"],"HWT7s6":["National Technical Institute for the Deaf, Rochester Institute of Technology"],"EOz7nJ":["Stewards"],"AkeObK":["Armenian"],"puHibH":["Armenian Translators Team"],"/IkoRr":["Azerbaijani"],"h6Cm55":["Khan Academy Azərbaycanca"],"6e+N4u":["Bangla"],"wIu5Fg":["Bangla team"],"KhEBDR":["Bulgarian"],"1gIyyA":["Bulgarian translation team"],"WRBPIL":["Burmese"],"xlD7eK":["Burmese team"],"6imsQS":["Chinese (Simplified)"],"1cHhAU":["Chinese translation team"],"w9VTXG":["Czech"],"Vp3+oc":["Czech team"],"Fo2vDn":["Danish"],"nskRnE":["Danish team"],"KIjvtr":["Dutch"],"GKB5Hu":["Khan Academy Netherlands project"],"ozAUWw":["Dutch/Flemish team"],"nLC6tu":["French"],"tALs3H":["France: ",["sm"]],"ZWu3NF":["Belgium: ",["aa"],", ",["cc"],", ",["hd"],", ",["vd"]],"Us/T9M":["French team"],"B7i/QN":["Private donors"],"tYgrDA":["Fulfulde Mbororoore"],"17Lyf3":["Georgian"],"DDcvSo":["German"],"CZXzs4":["Greek"],"2S30OA":["Greek team"],"sGpqyx":["Gujarati"],"tGjibo":["Hindi"],"mkWad2":["Hungarian"],"n+XBmS":["Hungarian team"],"Lj7sBL":["Italian"],"dFtidv":["Japanese"],"lUZRxC":["Japanese team"],"ffJEXe":["Kannada"],"xsL998":["Kazakh (Qazaq)"],"IDEAeY":["Project managers: ",["as"],", ",["gk"]],"Fb6WVr":["Khmer"],"h6S9Yz":["Korean"],"37buSP":["Korean team"],"bM2lhH":["Kyrgyz"],"/0YsGP":["Latvian"],"Ot2qtY":["Lithuanian"],"sBc/n8":["Mongolian"],"1IipHp":["Norwegian"],"xmWhgF":["Pashto"],"u2t8u0":["Pashto team"],"trnWaw":["Polish"],"0T+nQZ":["Portuguese, Brazilian"],"UJIkL3":["Portuguese, European"],"No69Mi":["European Portuguese team"],"uJc01W":["Romanian"],"Nr6W74":["Romanian team"],"nji0/X":["Russian"],"9aBtdW":["Serbian"],"65A04M":["Spanish"],"UaISq3":["Swedish"],"fb427h":["Tamil"],"SUr44j":["Thai"],"Kz91g/":["Turkish"],"MSFBM6":["Turkish team"],"V9+2pH":["Ukrainian"],"tmwuH9":["Urdu"],"pcaPst":["Ministry of Federal Education and Professional Training, Pakistan"],"b1dG47":["Uzbek"],"h7lJJX":["Uzbek team"],"fROFIL":["Vietnamese"],"tm9PCX":["Vietnamese team"],"51ESHW":["Xhosa / Zulu"],"R4ta4x":["Xhosa and Zulu team"],"9bPnVK":["Volunteers"],"i1bsyw":["Current Volunteers"],"4uxUZx":["Support Volunteer, Discussion community Guardian, Special Projects (2017 - present)"],"oUau81":["Support Volunteer, Special Projects (2017 - present)"],"e6Wgmv":["Support Volunteer (2017 - present)"],"I6CBPl":["Support Volunteer, Discussion community Guardian, Special Projects (2015 - present)"],"kvUyw0":["Support Volunteer (2016 - present)"],"YHvUcw":["Discussion community Guardian (2012 - present)"],"wC8Vh1":["Support Volunteer, Discussion community Guardian (2016 - present)"],"Ne2A9E":["Discussion community Guardian (2017 - present)"],"nUQoBI":["Discussion community Guardian (2015 - present)"],"aV61Hv":["Past Volunteers"],"0xPnJt":["Special Projects (2015)"],"3CY1Er":["Special Projects (2010)"],"/gH06h":["Discussion community Guardian (2012 - 2014)"],"IfJ4Ip":["Special Projects (2010 - 2011)"],"0Dvrpe":["Discussion community Guardian (2012 - 2017)"],"os9Mr3":["Discussion community Guardian (2013 - 2014)"],"2un8/l":["Special Projects (2015 - 2016)"],"Ee3m/A":["Support Volunteer (2014)"],"KHttQx":["Special Projects, Discussion community Guardian (2013 - 2014)"],"KRGS21":["Support Volunteer (2015)"],"Ud5Rk1":["Discussion community Guardian (2014)"],"sECobB":["Support Volunteer (2014 - 2016)"],"GRZ2pp":["Special Projects (2016)"],"I4bWwz":["Discussion community Guardian, Support Volunteer (2016 - 2017)"],"w6w8fE":["Discussion community Guardian (2014 - 2016)"],"UUkSDv":["Support Volunteer (2016 - 2018)"],"EM1pV6":["Discussion community Guardian (2012)"],"Y8BAIu":["Special Projects (2012)"],"ZH6xDE":["Support Volunteer, Discussion community Guardian (2014 - 2016)"],"i0eUMm":["Discussion community Guardian (2017)"],"VBUPU2":["Support Volunteer (2014 - 2017)"],"N5LquO":["Support Volunteer, Discussion community Guardian, Special Projects (2014 - 2017)"],"jekqSt":["Volunteering for Khan Academy makes me feel like, in my small way, I’m helping to change the world."],"P2nVAG":[["name"],", 36"],"7SU1zt":["Volunteer Credits"],"yLZJFO":["Want to help Khan Academy support even more learners?"],"ylsyyq":["Volunteer"],"hEhr5T":["Khan Academy would like to thank all who’ve dedicated their time, energy, and expertise to our mission."],"WN2RNI":["People holding hands"],"2bXHJO":["Our Contributors"]};

let results: Record<string, string | string[]> | undefined = undefined;
let promise: Promise<void> | null = null;

// We keep track of locales that are missing translations so we can load the
// English strings for those locales.
// NOTE(john): This array is replaced with the list of locales.
const missingTranslations: string[] = ["ur","zh-hant","sgn-us","is","en-x-rtl","zu","xh","th","sw","fa","ms","he","fa-af","sq"];

// We keep track of locales that have been bundled together in the same file
// so we can load them all at once.
const extraLocales: string[] = ["te","or","mr"];

/**
 * Load the i18n strings for the current locale and add them to the Lingui i18n
 * instance. This uses Suspsense so you'll want to make sure that your
 * component is wrapped in a Suspense (for loading) and an ErrorBoundary
 * (for errors).
 *
 * This function is called by the LoadStrings component, which is a Loadable
 * component that loads the strings for a route and all descendant imports.
 *
 * You can use this directly or you can use the withStrings HoC to load
 * strings for a component.
 */
export const useStrings = () => {
    if (results) {
        return results;
    }

    const locale = RequestInfo.kaLocale;

    // If the locale is English, or doesn't have any translations, we don't need to load
    // any additional strings.
    if (locale === "en" || missingTranslations.includes(locale)) {
        // Load the English strings into Lingui. This serves as a fallback for
        // locales that don't have any translations (and the actual strings for the English
        // locale).
        results = enStrings;
        i18n.load(locale, results);
        return results;
    }

    if (!promise) {
        promise = (async () => {
            const locale = RequestInfo.kaLocale;
            const localeFile = extraLocales.includes(locale) ? "extra" : locale;

            if (process.env.NODE_ENV === "production") {
                const result = (await import(`./lingui/${localeFile}.json`))
                    .default;
                results = localeFile === "extra" ? result[locale] : result;
            } else {
                results = {};
            }

            // Load the strings into Lingui
            i18n.load(locale, {...enStrings, ...results});

            promise = null;
        })();
    }

    throw promise;
};

/**
 * The HOC to load i18n strings for a route and all descendant imports.
 *
 * Examples:
 *
 * - export default withStrings(WrappedComponent);
 *
 * - export default compose(
 *      withStrings,
 *      withRouter
 *   )(WrappedComponent);
 */
export const withStrings = <C extends object>(
    WrappedComponent: React.ComponentType<C>,
) => {
    if (process.env.NODE_ENV === "test") {
        return WrappedComponent;
    }

    // Try to create a nice displayName for React Dev Tools.
    const displayName =
        WrappedComponent.displayName || WrappedComponent.name || "Component";

    // Creating the inner component.
    const WrapperComponent = (props: C): React.ReactNode => {
        useStrings();
        return <WrappedComponent {...(props as C)} />;
    };

    WrapperComponent.displayName = `withStrings(${displayName})`;

    return WrapperComponent;
};
